import { CURSOR_TYPES } from '@/pages/benefits/events/constants'

export const containerStyles = {
  background: 'none',
  border: 'none',
  cursor: CURSOR_TYPES.GRAB,
  maxWidth: '100%',
  outline: 'none',
  overflow: 'hidden',
  padding: 0,
  textAlign: 'left',
  whiteSpace: 'nowrap'
}

export const textStyles = {
  display: 'inline-block',
  minWidth: '100%',
  paddingRight: '8px'
}

export default () => {}
